<template>
    <div>
      <router-view />
    </div>
</template>
  
<script>
export default {
    name: 'StoreSwitcher',
    mounted() {
        const storename = this.$route.query.storename;
        if (storename === 'aventus') {
            this.$router.replace({ path: '/review/store', query: { storename }});
        } else {
            this.$router.replace({ path: '/review', query: { storename } });
        }
    }
}
</script>
  